import { Injectable, OnDestroy } from '@angular/core';
import { generateUniqueId } from '../../../../shared/utils/uuid.utils';
import {
  LOCAL_STORAGE_KEYS,
  LOCAL_STORAGE_PREFIXES,
} from '../../../../shared/constants/local-storage.constants';
import { getBrowserTabCounts } from './browser-tab-tracking.utils';

@Injectable({
  providedIn: 'root',
})
export class BrowserTabTrackingService implements OnDestroy {
  private _tabId = LOCAL_STORAGE_PREFIXES.TAB + generateUniqueId().replaceAll('-', '');
  private _tabHeartbeatInterval?: number | null = null;

  constructor() {}

  public initialize(): void {
    this._registerTab();
    this._scheduleTabHeartbeat();
    window.addEventListener('beforeunload', this._onTabClose);
  }

  public _registerTab(): void {
    localStorage.setItem(this._tabId, String(Date.now()));
  }

  public _unregisterTab(): void {
    localStorage.removeItem(this._tabId);
  }

  private _onTabClose = async (): Promise<void> => {
    this._unregisterTab();

    if (getBrowserTabCounts() === 0) {
      localStorage.removeItem(LOCAL_STORAGE_KEYS.OPEN_TABS);
    }
  };

  private _scheduleTabHeartbeat(): void {
    this._tabHeartbeatInterval = window.setInterval(() => {
      this._registerTab();
    }, 1000);
  }

  public ngOnDestroy(): void {
    window.removeEventListener('beforeunload', this._onTabClose);
    if (this._tabHeartbeatInterval) {
      clearTimeout(this._tabHeartbeatInterval);
    }
  }
}
